import { createRoute } from "@tanstack/solid-router";
import { MODALITY_IN_PERSON_KEY } from "@space/shared";
import { appRoute } from "./route";
import { withFeatureGate } from "@/features/flags/feature-gate";
import { CheckinView } from "@/features/academy/components/checkin-view";

export const checkinRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/checkin",
  // §L1 · online-first: code-based roll call is IN-PERSON. The route still
  // exists (no 404): it shows the "disabled by your academy" state, which
  // explains that nothing was deleted and everything comes back on re-enabling.
  component: withFeatureGate(MODALITY_IN_PERSON_KEY, CheckinView),
});
